import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'rcp-section-filter-bar',
  template: `
    <div class="rcp-section-filter-bar">
      <div class="section-filter-bar-content">
        <ng-content></ng-content>
      </div>

      <div class="section-filter-bar-actions global-component-style-flex-gap">
        <ng-content select="[actions]"></ng-content>
      </div>
    </div>
  `,
  styleUrls: ['./section-filter-bar.component.scss'],
  imports: [],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class SectionFilterBarComponent {}
